import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/stairs-calculator',
  component: () => import('../../routes/StairsCalculator.svelte'),
  card: {
    id: 'stairs-calculator',
    title: 'Stairs Calculator',
    description: 'Calculate the number of risers, treads, run length, diagonal, and angle for any stair configuration.',
    icon: 'stairs',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/stairs-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Stairs Calculator – Calculate Rise, Run, Treads & Riser Height',
    description: 'Free stairs calculator to compute the number of risers, treads, total run, diagonal length, and incline angle. IBC code compliant.',
  },
};

export default meta;